import { render, staticRenderFns } from "./scope16.vue?vue&type=template&id=27ae5705&scoped=true"
import script from "./scope16.vue?vue&type=script&lang=js"
export * from "./scope16.vue?vue&type=script&lang=js"
import style0 from "./scope16.vue?vue&type=style&index=0&id=27ae5705&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae5705",
  null
  
)

export default component.exports